import { AlertCircle } from "lucide-react";
import React from "react";

interface CalendarAlertsProps {
  isError: boolean;
  error?: any;
  isCalendarEnabled: boolean;
}

export const CalendarAlerts: React.FC<CalendarAlertsProps> = ({
  isError,
  error,
  isCalendarEnabled,
}) => {
  if (isError) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4 mx-6 mb-4">
        <div className="flex items-start">
          <AlertCircle className="h-5 w-5 text-red-500 mr-3 flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="text-red-800 font-medium">
              Unable to load calendar events
            </h3>
            <p className="text-red-600 text-sm mt-1">
              {error?.message ||
                "There was an error connecting to Google Calendar. Please try again later."}
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (!isCalendarEnabled) {
    return (
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mx-6 mb-4">
        <div className="flex items-start">
          <AlertCircle className="h-5 w-5 text-yellow-500 mr-3 flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="text-yellow-800 font-medium">
              Calendar integration not configured
            </h3>
            <p className="text-yellow-600 text-sm mt-1">
              Google Calendar API credentials are not set up. Contact the
              administrator to enable calendar features.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return null;
};
